export default __webpack_public_path__ + "static/media/018-math.18d48c37.png";